import RequestManager from 'src/requests/RequestManager';
import { Phase } from '../interfaces';
import { isMockDataActive } from '../mockData';
import { StructureTask } from '../tasks';
import { parsePhase } from '../utils';
import { structure as structureMock } from '../mockData'

enum PhasesTypes {
    GROUP = "PHASE_GROUP",
    ROUND = "PHASE_ROUND",
    MATCHROUND = "PHASE_MATCHROUND"
}

// Se usa en NodoMundial
export default async function getPhases(): Promise<{
    groups: Phase[],
    rounds: Phase[],
    matchRounds: Phase[]
}> {
    const task = new StructureTask();
    let structure;
    if(isMockDataActive) {
        structure = structureMock;
    } else {
        structure = await RequestManager.addRequest(task);
    }

    const phases = structure.phases || [];
    const groups = phases.filter((phase: any) => phase.typeDetail === PhasesTypes.GROUP).map(parsePhase);   
    const rounds = phases.filter((phase: any) => phase.typeDetail === PhasesTypes.ROUND).map(parsePhase);
    const matchRounds = phases.filter((phase: any) => phase.typeDetail === PhasesTypes.MATCHROUND).map(parsePhase);

    return {
        groups,
        rounds,
        matchRounds
    }
};


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getPhases.ts